import { initializeApp } from "firebase/app";

import {
  getFirestore,
  collection,
  addDoc,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  getDoc,
  query,
  where,
  onSnapshot,
  orderBy,
  limit,
  collectionGroup,
  deleteDoc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";

import {
  getAuth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updateEmail,
  updatePassword,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCCN0OXa42t_5R59cmf5PrQFxc6lBbFkXE",
  authDomain: "prism-a6a80.firebaseapp.com",
  databaseURL: "https://prism-a6a80-default-rtdb.firebaseio.com",
  projectId: "prism-a6a80",
  storageBucket: "prism-a6a80.appspot.com",
  messagingSenderId: "568824200639",
  appId: "1:568824200639:web:a765855755a8fcb50c350a",
  measurementId: "G-85DYX2J6G8",
};
const {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} = require("firebase/app-check");

const app = initializeApp(firebaseConfig);

// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to initializeAppCheck().
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    "6Lf618MeAAAAAAxmpSBrHDG-gtjO1DI1A4qX_3rz"
  ),
  isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
});

const functions = getFunctions(app);
const db = getFirestore();
const storage = getStorage(app);

export const auth = getAuth();
const analytics = getAnalytics(app);

// window.dataLayer = window.dataLayer || [];
// function gtag() {
//   window.dataLayer.push(arguments);
// }
// gtag("config", "G-BYW09Q0K5D", {
//   ignore_referrer: "false",
//   currency: "USD",
// });

export {
  db,
  collection,
  addDoc,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  getDoc,
  query,
  where,
  onSnapshot,
  orderBy,
  limit,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  collectionGroup,
  deleteDoc,
  updateEmail,
  updatePassword,
  functions,
  httpsCallable,
  app,
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  storage,
  uploadBytes,
  deleteObject,
  serverTimestamp,
  analytics,
  logEvent,
  setUserProperties,
  arrayUnion,
  arrayRemove,
};
